// 按需引入
import * as echarts from 'echarts/core';
import { PieChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([ PieChart, CanvasRenderer ]);

// echarts 饼图配置
const option = {
  series: [{
    type: 'pie',
    startAngle: 0,              // 饼图的起始角度(直角坐标系里的0度)
    clockwise: false,           // 扇区按逆时针排布
    animation: false,           // 鼠标移动到扇区上时，关闭动画
    radius: [0, '85%'],         // 饼图的半径, [内半径，外半径]
    selectedOffset: 20,         // 选中时，突出显示
    selectedMode: 'single',     // 单选模式
    label: { show: false },     // 隐藏饼图图形上的文本标签
    labelLine: { show: false }, // 隐藏标签的视觉引导线
    emphasis: {                 // 高亮状态的扇区和标签样式
      itemStyle: {
        shadowBlur: 10,
        shadowOffsetX: 0,
        shadowColor: 'rgba(0, 0, 0, 0.5)',
      },
    },
  }],
};

export { echarts, option };
